import React from 'react'
import { Create, SimpleForm, TextInput, ReferenceInput, SelectInput } from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import SectionTitle from '../components/SectionTitle'

const styles = {
  textInput: { width: 500 },
}

const useStyles = makeStyles(styles)

const TagCreate = (props) => {
  const classes = useStyles()
  return (
    <Create {...props}>
      <SimpleForm>
        <SectionTitle label="Create Tag" />
        <ReferenceInput source="tagTypeId" reference="tag-types" label="Tag Type" required>
          <SelectInput optionText="name" formClassName={classes.textInput} fullWidth />
        </ReferenceInput>
        <TextInput source="name" formClassName={classes.textInput} fullWidth required />
        <TextInput source="description" formClassName={classes.textInput} fullWidth multiline rows={3} />
      </SimpleForm>
    </Create>
  )
}

export default TagCreate

